declare const qrcode: any;

import { state } from '../state/app-state';
import { MOCK } from '../state/device';
import { apiMintShare } from '../api/client';
import { $ } from './dom';
import { showToast } from './toast';

export function renderShareQr(url: string){
  const qrBox = $('qr');
  qrBox.innerHTML = '';
  const qr = qrcode(0, 'M'); qr.addData(url); qr.make();
  const size = qr.getModuleCount();
  let svg = `<svg xmlns="http://www.w3.org/2000/svg" width="134" height="134" viewBox="0 0 ${size} ${size}" shape-rendering="crispEdges">`;
  svg += `<rect width="${size}" height="${size}" fill="#FFFFFF"/>`;
  for(let r=0;r<size;r++) for(let c=0;c<size;c++){
    if(qr.isDark(r,c)) svg += `<rect x="${c}" y="${r}" width="1" height="1" fill="#1F1B16"/>`;
  }
  svg += '</svg>';
  qrBox.innerHTML = svg;
}
// Don't reuse a cached mint that's within this window of expiry — re-mint so
// the user never copies a link that dies moments later (e.g. a 1h share
// reopened near its end).
const SHARE_CACHE_GRACE_MS = 60_000;
export async function buildShareUrl(){
  const range     = ['24h','7d','all'][state.shareSel.range];
  const precision = ['exact','1km','city'][state.shareSel.precision];
  const expires   = ['1h','1d','1w','never'][state.shareSel.expires];
  const tupleKey  = `${range}.${precision}.${expires}`;
  const urlEl  = $('share-url');
  const qrBox  = $('qr');

  // No device yet (share modal is map-screen only, so this is theoretically
  // unreachable, but be defensive — the picker is the only state with
  // MOCK.device == null and the open-share button is hidden there).
  if(!MOCK.device || !MOCK.device.token){
    urlEl.value = '';
    qrBox.innerHTML = '';
    return;
  }

  // Cache key is per-device: a mint belongs to one device, so switching
  // devices must never serve another device's token for the same tuple.
  const deviceToken = MOCK.device.token;
  const cacheKey = `${deviceToken}|${tupleKey}`;

  // Cached mint for this device+tuple → reuse, no re-sign, no re-mint — but
  // only while the share is comfortably unexpired. A cached entry whose share
  // has expired (or is within the grace window) is evicted and re-minted;
  // otherwise re-sharing with the same settings would hand back a dead link.
  const cached = state.mintedShare.get(cacheKey);
  if(cached && (cached.expires_at == null || cached.expires_at - Date.now() > SHARE_CACHE_GRACE_MS)){
    const url = `${location.origin}/#/s/${cached.share_token}`;
    urlEl.value = url;
    renderShareQr(url);
    return;
  }
  if(cached) state.mintedShare.delete(cacheKey);

  // Optimistic placeholder while the mint round-trips.
  urlEl.value = 'minting…';
  qrBox.innerHTML = '';

  try {
    const minted = await apiMintShare(deviceToken, { range, precision, expires });
    state.mintedShare.set(cacheKey, minted);
    // The user may have toggled to a different tuple — or switched devices —
    // while we were waiting; only render if our device+tuple still matches.
    const curRange     = ['24h','7d','all'][state.shareSel.range];
    const curPrecision = ['exact','1km','city'][state.shareSel.precision];
    const curExpires   = ['1h','1d','1w','never'][state.shareSel.expires];
    if(`${curRange}.${curPrecision}.${curExpires}` !== tupleKey) return;
    if(MOCK.device?.token !== deviceToken) return;
    const url = `${location.origin}/#/s/${minted.share_token}`;
    urlEl.value = url;
    renderShareQr(url);
  } catch(err: any){
    console.warn('[locus] share-mint failed', err);
    urlEl.value = '';
    qrBox.innerHTML = '';
    const status = err && err.status;
    if(status === 429) showToast('share mint rate-limited; try in a moment');
    else if(status === 401) showToast('share mint signature rejected');
    else showToast('share mint failed');
  }
}
